var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:(_vm.branches == 1 ? { customClass: 'my-tooltip-class' } : {}),expression:"branches == 1 ? { customClass: 'my-tooltip-class' } : {}"}],staticClass:"btn dealers_btn",attrs:{"to":{
      name: 'branchDashboard',
      query: {
        branchId: _vm.data.id,
        companyId: this.$route.query.companyId
          ? this.$route.query.companyId
          : _vm.data.companyId,
        dealerId: this.$route.query.dealerId
          ? this.$route.query.dealerId
          : _vm.data.dealerId,
      },
    },"title":_vm.data.detailsTip}},[_c('i',{staticClass:"fa fa-eye primary-color"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }